<p class="capital-title">Validamos tu identidad</p>
<p class="welcome-subtitle">Este proceso te tomará unos minutos. Te contamos los pasos que tendrá:</p>
<app-capital-button title="Paso 1: Verificar cédula de identidad" subtitle="Debes tener tu cédula a mano."
    icon="/img/id-card.svg">
</app-capital-button>
<div class="mb-4"></div>
<app-capital-button title="Paso 2: Validar huella" subtitle="Debes colocar tu dedo en el lector."
    icon="/img/long-touch.svg">
</app-capital-button>
<div class="mb-4"></div>
<app-primary-button text="Comenzar la validación" (click)="click.emit()" (keypress)="click.emit()" [disabled]="disabled()"></app-primary-button>